import type { FunctionComponent } from 'react';
import { mapIconIdToJSXElement } from '../../../helpers/iconHelpers';

interface EllipsisIconProps {
  iconName: string;
  title?: string;
  id?: string;
}

export const EllipsisIcon: FunctionComponent<EllipsisIconProps> = ({ iconName, title, id }) => {
  return <>{mapIconIdToJSXElement(iconName, title, id)}</>;
};
